module.exports = __webpack_public_path__ + "static/img/3en.0c9b0b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/3en.png
// module id = h2hU
// module chunks = 0